import { LogoutLink } from '@ui/links';
import { LogoutOutlined } from '@ant-design/icons';
import React from 'react';
import { SonarMenuItem } from '@ui/menu';

export const logoutMenuItem: SonarMenuItem = {
	icon: <LogoutOutlined />,
	id: 'logout-menu-item',
	key: 'Logout',
	label: <LogoutLink />
};
